module.exports = __webpack_public_path__ + "static/media/banner5.170c7a2e.jpg";